import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { JobOfferMediaCount, JobOfferMedia } from "@/lib/redux/context";

interface JobOfferMediasState {
  mediaList: JobOfferMedia[];
  countsByDate: JobOfferMediaCount[];
  mediaLoading: boolean;
  countsLoading: boolean;
  mediaError: string | null;
  countsError: string | null;
  lastCountsFetchParams: {
    startDate: string | null;
    endDate: string | null;
  };
}

const initialState: JobOfferMediasState = {
  mediaList: [],
  countsByDate: [],
  mediaLoading: false,
  countsLoading: false,
  mediaError: null,
  countsError: null,
  lastCountsFetchParams: {
    startDate: null,
    endDate: null,
  },
};

const jobOfferMediasSlice = createSlice({
  name: "jobOfferMedias",
  initialState,
  reducers: {
    // Media actions
    fetchJobOfferMediasStart(state) {
      state.mediaLoading = true;
      state.mediaError = null;
    },
    fetchJobOfferMediasSuccess(state, action: PayloadAction<JobOfferMedia[]>) {
      state.mediaList = action.payload;
      state.mediaLoading = false;
      state.mediaError = null;
    },
    fetchJobOfferMediasFailure(state, action: PayloadAction<string>) {
      state.mediaLoading = false;
      state.mediaError = action.payload;
    },

    // Counts actions
    fetchJobOfferMediaCountsStart(
      state,
      action: PayloadAction<{ startDate: string; endDate: string }>,
    ) {
      state.countsLoading = true;
      state.countsError = null;
      state.lastCountsFetchParams = {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };
    },
    fetchJobOfferMediaCountsSuccess(
      state,
      action: PayloadAction<JobOfferMediaCount[]>,
    ) {
      state.countsByDate = action.payload;
      state.countsLoading = false;
      state.countsError = null;
    },
    fetchJobOfferMediaCountsFailure(state, action: PayloadAction<string>) {
      state.countsLoading = false;
      state.countsError = action.payload;
    },

    // Common clear action
    clearJobOfferMediasData(state) {
      state.mediaList = [];
      state.countsByDate = [];
      state.lastCountsFetchParams = {
        startDate: null,
        endDate: null,
      };
      state.mediaError = null;
      state.countsError = null;
    },
  },
});

export const {
  fetchJobOfferMediasStart,
  fetchJobOfferMediasSuccess,
  fetchJobOfferMediasFailure,
  fetchJobOfferMediaCountsStart,
  fetchJobOfferMediaCountsSuccess,
  fetchJobOfferMediaCountsFailure,
  clearJobOfferMediasData,
} = jobOfferMediasSlice.actions;

export default jobOfferMediasSlice.reducer;
